import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import Services from '@/components/Services';
import Portfolio from '@/components/Portfolio';
import About from '@/components/About';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import LoadingScreen from '@/components/LoadingScreen';
import SEO from '@/components/SEO';

const Index = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (ref) {
      localStorage.setItem('rlx_ref_code', ref.toUpperCase());
      localStorage.setItem('rlx_ref_code_ts', Date.now().toString());
    }
  }, [searchParams]);

  return (
    <>
      <SEO
        title="RLX Digital Agency Hong Kong | Web Design, Apps & Branding"
        description="Hong Kong digital agency for custom websites, mobile apps, UI/UX, logo design and brand identity for growing businesses."
        path="/"
        staticHead
      />
      <LoadingScreen />
      <main className="min-h-screen">
        <Header />
        <Hero />
        <Services />
        <Portfolio />
        <About />
        <Contact />
        <Footer />
      </main>
    </>
  );
};

export default Index;
